import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckSuccess } from '../CheckSuccess';

export const LibraryCheckSuccess: FC = () => {
  const { t } = useTranslation();

  return <CheckSuccess text={t('library.list.success')} />;
};
